var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splitpanes__pane",style:(_vm.style),on:{"click":function($event){return _vm.onPaneClick($event, _vm._uid)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }